import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { observer, Observer } from 'mobx-react';
import styled from 'styled-components';

import Header, { sections, SectionsConfig } from './Header';
import ViewModal from './ViewModal'
import Records from './Records';
import Contacts from './ContactBox';
import VisitModal from './Visit'

import { useLocation } from 'react-router-dom';
import { getEventById, getEventByName } from './utils';
import { useHorsesStore } from '../../../stores/horses'
import { toJS } from 'mobx'
import {
    ScrollingProvider,
    Section,
} from 'react-scroll-section';
import { config } from 'process';
import { Grid } from '@mui/material';


type DetailsProps = {
    id?: string
}
type VisitCallBack = { title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any, rename?: string, visitId?: string }
const App: FunctionComponent<DetailsProps> = (props) => {
    const state = useLocation<DetailsProps>().state;
    const [openModal, setOpenModal] = useState(false)
    const [openAddVisit, setOpenAddVisit] = useState(false)
    const [currentViewModal, setCurrentViewModal] = useState<{
        title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any, rename?: string
    }>(
        { title: '', subtitle: undefined, actionTitle: undefined }
    )
    const [visitSate, setVisitSate] = useState<string | undefined>()
    const stores = useHorsesStore()

    const [visit, setVisit] = useState<typeof stores.visits[number]>()
    useEffect(() => {
        if (state?.id) {
            stores.get(String(state.id))
            stores.getContact(String(state.id))
        }

        stores.changeEditeMode(true)
        console.log(toJS(stores.contacts))
    }, [])

    const handleModalCallback = (p: VisitCallBack) => {

        switch (p.title) {
            case 'Show':
                setCurrentViewModal({
                    ...p,
                    rename: 'Results',
                    subtitle: 'Result Date:',
                    actionTitle: 'Add Show',
                })
                break;
            case 'Feed':
                setCurrentViewModal({
                    ...p,
                    subtitle: 'Date:',
                })
                break;
            case 'Work':
                setCurrentViewModal({
                    ...p,
                    subtitle: 'Date Worked:',
                })
                break;
            default:
                setCurrentViewModal(p)
                break;
        }
    }
    const onClick = (visitId: string, title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any) => {
        const visit = stores.visits.find(item => item._ID == visitId)
        handleModalCallback({ title: title, subtitle: subtitle, actionTitle: actionTitle, noReminder: noReminder, config: config, visitId: visitId })
        setVisit(visit)
        setOpenModal(true)
    }

    const onAddClick = (profileId: string, title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any, visitId?: string) => {
        handleModalCallback({ title: title, subtitle: subtitle, actionTitle: actionTitle, noReminder: noReminder, config: config, visitId: visitId })

        setOpenAddVisit(true)
        stores.visitActionModify({
            id: state.id!,
            action: 'add'
        })
    }

    const onEditClick = (visitId: string, title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any) => {
        handleModalCallback({ title: title, subtitle: subtitle, actionTitle: actionTitle, noReminder: noReminder, config: config, visitId: visitId })
        setOpenAddVisit(true)
        stores.visitActionModify({
            id: visitId,
            action: 'edit'
        })
    }



    return <Observer>{() => <Wrapper container spacing={2}>
        <Grid item xs={12}>
            <ScrollingProvider>
                <Header horseId={state?.id != undefined ? String(state.id) : undefined} />
                {state?.id != undefined ? Object.keys(SectionsConfig).map((key, index) => {
                    const content = stores.visits.filter(item => getEventById({ _ID: Number(item.event_type) }) == key)
                    const contacts = stores.contacts.find(item => getEventById({ _ID: Number(item.event_type) }) == key)
                    const config = SectionsConfig[key]
                    return <Section id={key}>
                        <Records
                            title={key}
                            profileId={state?.id}
                            visits={content}
                            onClick={onClick}
                            onAddVisit={onAddClick}
                            config={config}
                            onEditClick={onEditClick}
                            color={config.recColor}
                            subTitle={config.subtitle}
                            noReminder={config.noReminder}
                        />
                        {config.showContacts == true ?
                            <Contacts
                                color={config.contactColor}
                                title={key}
                                profileId={state?.id}
                                onAddVisit={onAddClick}
                                contacts={toJS(contacts)}
                                onClick={onClick}
                                config={config}
                            />
                            : null}
                    </Section>
                }) : null}
            </ScrollingProvider>

            <ViewModal open={openModal} close={() => setOpenModal(false)} {...visit}  {...currentViewModal} />
            <VisitModal
                open={openAddVisit}
                close={() => {
                    setVisitSate(undefined)
                    setOpenAddVisit(false)
                }}

                {...currentViewModal}
                event_type={Number(getEventByName({ name: currentViewModal.title }))}
            /></Grid>
    </Wrapper>}</Observer>
}


const Wrapper = styled(Grid)`
    display:flex;
    flex:1;
    flexDirection:column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height:600px;
    width:100%;
    height:100%;
`

export default observer(App)